/**
 * Set and display modal box content
 * @param  {Boolean} tracking Enable/Disable datalayer tracking
 * @param  {String} type      Modal box type (video, buyGame)
 * @param  {String} className Modal box classes
 * @param  {String} data      Modal box context and content
 */

 import { useContext, useCallback } from 'react'
 import { PageContext } from '../contexts/page-context'

 const useModalBox = () => {
  const { modalState, modalCont } = useContext(PageContext)
  const [modalOpen, setModalOpen] = modalState
  const [modalContent, setModalContent] = modalCont

  // Open Modal
  const openModalBox = useCallback(( type, className, data, closeEvent) => {
    let content = {
      className: className,
      type: type,
      data: data,
      closeEvent: closeEvent
    }
    
    setModalOpen(true)
    setModalContent(content)
  }, [])
  
  return [modalOpen, openModalBox]
}
export default useModalBox